const SMALL_WORDS = new Set(["and", "or", "of", "the"]);

function formatWord(word: string, index: number) {
  if (!word) return word;
  if (index > 0 && SMALL_WORDS.has(word)) return word;
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function formatCatalogTaxonomyLabel(value: string) {
  const normalized = value.replace(/[_-]+/g, " ").trim().toLowerCase();
  if (!normalized) return value;
  return normalized.split(/\s+/).map(formatWord).join(" ");
}

type TaxonomyTranslator = ((key: never) => string) & {
  has?: (key: never) => boolean;
};

export function formatTranslatedCatalogTaxonomyLabel(
  value: string,
  translator: TaxonomyTranslator,
) {
  const key = value as never;
  return translator.has?.(key) ? translator(key) : formatCatalogTaxonomyLabel(value);
}
